import { call, put } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import type { PayloadAction } from '@reduxjs/toolkit'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { Actions_Notifications } from 'redux/modules/notification/Actions'
import { Actions_CurrentStaffMember } from 'redux/modules/currentStaffMember/Actions'

const { remove } = RequestMethods()

export interface ISagaWorker_DeleteStaff {
  id: number
  navigateToStaffTable: () => void
}

export default function* SagaWorker_DeleteStaff(action: PayloadAction<ISagaWorker_DeleteStaff>) {
  const { id, navigateToStaffTable } = action.payload
  yield put(Actions_CurrentStaffMember.store.showLoader())

  try {
    yield call(async () => await remove(`/users/${id}`))

    yield put(Actions_CurrentStaffMember.store.clearCurrentStaffMember())

    navigateToStaffTable()
    yield put(Actions_Notifications.store.setNotification({ message: 'Staff deleted successfully', type: 'Success' }))
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_CurrentStaffMember.store.hideLoader())
  }
}
